import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  nome: Yup.string().required(mensagemPadrao),
  cnpj: Yup.string().required(mensagemPadrao)
})
